function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M198.098 24.326L87.543 134.881 38.891 86.229 0 125.121l87.543 87.541L236.988 63.217z"
});

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236.988 236.988",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _ref);
}

export default SvgCheck;